/* tslint:disable */
/* eslint-disable */
/* @relayHash e034ba6ef01653c4e1747f017f6f9f37 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type TAG = "ADMIN" | "EXPERT" | "FEATURED" | "MEMBER" | "MODERATOR" | "QUESTION" | "REVIEW" | "STAFF" | "UNANSWERED" | "%future added value";
export type CreateCommentReplyInput = {
    nudge?: boolean | null;
    storyID: string;
    parentID: string;
    parentRevisionID: string;
    body: string;
    clientMutationId: string;
    media?: CreateCommentMediaInput | null;
};
export type CreateCommentMediaInput = {
    type: string;
    id?: string | null;
    url: string;
    width?: string | null;
    height?: string | null;
};
export type CreateCommentReplyMutationVariables = {
    input: CreateCommentReplyInput;
    flattenReplies: boolean;
    refreshStream: boolean;
};
export type CreateCommentReplyMutationResponse = {
    readonly createCommentReply: {
        readonly edge: {
            readonly cursor: unknown;
            readonly node: {
                readonly id: string;
                readonly status: COMMENT_STATUS;
                readonly story: {
                    readonly settings: {
                        readonly live: {
                            readonly enabled: boolean;
                        };
                    };
                };
                readonly parent: {
                    readonly id: string;
                    readonly tags: ReadonlyArray<{
                        readonly code: TAG;
                    }>;
                } | null;
                readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabCommentContainer_comment">;
            };
        };
        readonly clientMutationId: string;
    };
};
export type CreateCommentReplyMutation = {
    readonly response: CreateCommentReplyMutationResponse;
    readonly variables: CreateCommentReplyMutationVariables;
};



/*
mutation CreateCommentReplyMutation(
  $input: CreateCommentReplyInput!
  $flattenReplies: Boolean!
  $refreshStream: Boolean!
) {
  createCommentReply(input: $input) {
    edge {
      cursor
      node {
        ...AllCommentsTabCommentContainer_comment_4768Eu
        id
        status
        story {
          settings {
            live {
              enabled
            }
          }
          id
        }
        parent {
          id
          tags {
            code
          }
        }
      }
    }
    clientMutationId
  }
}

fragment AllCommentsTabCommentContainer_comment_4768Eu on Comment {
  id
  seen
  ...CommentContainer_comment
  ...ReplyListContainer1_comment_4768Eu
  ...IgnoredTombstoneOrHideContainer_comment
  ...DeletedTombstoneContainer_comment
}

fragment ArchivedReportFlowContainer_comment on Comment {
  id
  story {
    url
    id
  }
}

fragment CaretContainer_comment on Comment {
  id
  ...ModerationDropdownContainer_comment
}

fragment CommentContainer_comment on Comment {
  id
  author {
    id
    username
    avatar
    badges
    featuredCommenter
    newCommenter
  }
  parent {
    id
    author {
      username
      id
    }
  }
  body
  createdAt
  status
  rating
  editing {
    edited
    editableUntil
  }
  tags {
    code
  }
  deleted
  actionCounts {
    reaction {
      total
    }
  }
  viewerActionPresence {
    dontAgree
    flag
  }
  seen
  canReply
  ...CaretContainer_comment
  ...EditCommentFormContainer_comment
  ...MediaSectionContainer_comment
  ...ReactionButtonContainer_comment
  ...ModerationRejectedTombstoneContainer_comment
  ...ReplyCommentFormContainer_comment
  ...ReportButton_comment
  ...ReportFlowContainer_comment
  ...UsernameContainer_comment
  ...UsernameWithPopoverContainer_comment
  ...UserTagsContainer_comment
  ...ArchivedReportFlowContainer_comment
}

fragment CopyCommentEmbedCodeContainer_comment on Comment {
  id
  author {
    id
    username
  }
  body
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
      }
      ... on TwitterMedia {
        url
      }
      ... on BlueskyMedia {
        url
      }
      ... on YouTubeMedia {
        url
      }
      ... on ExternalMedia {
        url
      }
    }
  }
}

fragment DeletedTombstoneContainer_comment on Comment {
  deleted
  id
}

fragment EditCommentFormContainer_comment on Comment {
  id
  body
  createdAt
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TenorMedia {
        url
        title
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on BlueskyMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
  }
  author {
    username
    id
  }
  editing {
    editableUntil
  }
  site {
    id
  }
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  id
  author {
    id
    username
  }
}

fragment LocalReplyListContainer_comment on Comment {
  id
}

fragment MediaSectionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TenorMedia {
        url
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on BlueskyMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment ModerationActionsContainer_comment on Comment {
  id
  author {
    id
  }
  body
  revision {
    id
  }
  status
  tags {
    code
  }
  ...CopyCommentEmbedCodeContainer_comment
}

fragment ModerationDropdownContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  status
  tags {
    code
  }
  ...ModerationActionsContainer_comment
  ...UserBanPopoverContainer_comment
}

fragment ModerationRejectedTombstoneContainer_comment on Comment {
  id
  ...CaretContainer_comment
}

fragment ReactionButtonContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  viewerActionPresence {
    reaction
  }
  actionCounts {
    reaction {
      total
    }
  }
}

fragment ReplyCommentFormContainer_comment on Comment {
  id
  site {
    id
  }
  author {
    username
    id
  }
  revision {
    id
  }
  ...ReplyEditedWarningContainer_comment
}

fragment ReplyEditedWarningContainer_comment on Comment {
  editing {
    edited
  }
  revision {
    id
  }
}

fragment ReplyListCommentContainer_comment on Comment {
  ...CommentContainer_comment
  ...IgnoredTombstoneOrHideContainer_comment
  ...DeletedTombstoneContainer_comment
}

fragment ReplyListContainer1_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer2_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer2_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer3_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer3_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer4_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer4_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer5_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer5_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer6_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer6_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainerLast_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainerLastFlattened_comment on Comment {
  status
  id
  ...ReplyListContainer_comment_1fYj9E
  replies(first: 10, orderBy: CREATED_AT_ASC, flatten: $flattenReplies, refreshStream: false) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        __typename
      }
      __typename
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainerLast_comment_4768Eu on Comment {
  ...LocalReplyListContainer_comment @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_comment @include(if: $flattenReplies)
}

fragment ReplyListContainer_comment_1fYj9E on Comment {
  id
  status
}

fragment ReplyListContainer_comment_4768Eu on Comment {
  id
  status
}

fragment ReportButton_comment on Comment {
  id
  author {
    username
    id
  }
  viewerActionPresence {
    dontAgree
    flag
    illegal
  }
}

fragment ReportCommentFormContainer_comment on Comment {
  id
  revision {
    id
  }
  story {
    url
    id
  }
}

fragment ReportFlowContainer_comment on Comment {
  ...ReportCommentFormContainer_comment
  id
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment UserBanPopoverContainer_comment on Comment {
  id
  revision {
    id
  }
  status
  author {
    id
    username
  }
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
  bio
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UsernameContainer_comment on Comment {
  id
  author {
    username
    id
  }
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "flattenReplies"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    } as any), v2 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "refreshStream"
    } as any), v3 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v4 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any), v5 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v6 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any), v7 = ({
        "alias": null,
        "args": null,
        "concreteType": "StorySettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "LiveConfiguration",
                "kind": "LinkedField",
                "name": "live",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enabled",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v8 = ({
        "alias": null,
        "args": null,
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v9 = ({
        "kind": "Variable",
        "name": "refreshStream",
        "variableName": "refreshStream"
    } as any), v10 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
    } as any), v11 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "seen",
        "storageKey": null
    } as any), v12 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v13 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v14 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            (v5 /*: any*/),
            (v12 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatar",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "badges",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "featuredCommenter",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newCommenter",
                "storageKey": null
            },
            (v13 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignoreable",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v15 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            (v12 /*: any*/),
            (v5 /*: any*/)
        ],
        "storageKey": null
    } as any), v16 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
    } as any), v17 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rating",
        "storageKey": null
    } as any), v18 = ({
        "alias": null,
        "args": null,
        "concreteType": "EditInfo",
        "kind": "LinkedField",
        "name": "editing",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "edited",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editableUntil",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v19 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
    } as any), v20 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionCounts",
        "kind": "LinkedField",
        "name": "actionCounts",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "kind": "LinkedField",
                "name": "reaction",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v21 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionPresence",
        "kind": "LinkedField",
        "name": "viewerActionPresence",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dontAgree",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flag",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reaction",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "illegal",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v22 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canReply",
        "storageKey": null
    } as any), v23 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v24 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v25 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any), v26 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v27 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v28 = [
        (v24 /*: any*/),
        (v26 /*: any*/)
    ], v29 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentRevision",
        "kind": "LinkedField",
        "name": "revision",
        "plural": false,
        "selections": [
            (v5 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                    (v23 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v24 /*: any*/),
                            (v25 /*: any*/),
                            (v26 /*: any*/),
                            (v27 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "still",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "video",
                                "storageKey": null
                            }
                        ],
                        "type": "GiphyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": (v28 /*: any*/),
                        "type": "TwitterMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": (v28 /*: any*/),
                        "type": "BlueskyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v24 /*: any*/),
                            (v26 /*: any*/),
                            (v27 /*: any*/)
                        ],
                        "type": "YouTubeMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v24 /*: any*/)
                        ],
                        "type": "ExternalMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v24 /*: any*/),
                            (v25 /*: any*/)
                        ],
                        "type": "TenorMedia",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v30 = ({
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
            (v5 /*: any*/)
        ],
        "storageKey": null
    } as any), v31 = ({
        "kind": "Literal",
        "name": "first",
        "value": 10
    } as any), v32 = ({
        "kind": "Literal",
        "name": "orderBy",
        "value": "CREATED_AT_ASC"
    } as any), v33 = [
        (v31 /*: any*/),
        (v32 /*: any*/),
        (v9 /*: any*/)
    ], v34 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replyCount",
        "storageKey": null
    } as any), v35 = ({
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
            (v5 /*: any*/),
            (v15 /*: any*/)
        ],
        "storageKey": null
    } as any), v36 = ({
        "alias": null,
        "args": null,
        "concreteType": "Story",
        "kind": "LinkedField",
        "name": "story",
        "plural": false,
        "selections": [
            (v24 /*: any*/),
            (v5 /*: any*/)
        ],
        "storageKey": null
    } as any), v37 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spamBanned",
        "storageKey": null
    } as any), v38 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pending",
        "storageKey": null
    } as any), v39 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastViewerAction",
        "storageKey": null
    } as any), v40 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasTraversalFocus",
        "storageKey": null
    } as any), v41 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enteredLive",
        "storageKey": null
    } as any), v42 = ({
        "kind": "ClientExtension",
        "selections": [
            (v37 /*: any*/),
            (v38 /*: any*/),
            (v39 /*: any*/),
            (v40 /*: any*/),
            (v41 /*: any*/)
        ]
    } as any), v43 = [
        ({
            "alias": null,
            "args": null,
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "localReplies",
            "plural": true,
            "selections": [
                (v5 /*: any*/),
                (v41 /*: any*/),
                (v14 /*: any*/),
                (v35 /*: any*/),
                (v16 /*: any*/),
                (v13 /*: any*/),
                (v6 /*: any*/),
                (v17 /*: any*/),
                (v18 /*: any*/),
                (v8 /*: any*/),
                (v38 /*: any*/),
                (v39 /*: any*/),
                (v19 /*: any*/),
                (v20 /*: any*/),
                (v21 /*: any*/),
                (v40 /*: any*/),
                (v11 /*: any*/),
                (v22 /*: any*/),
                (v37 /*: any*/),
                (v29 /*: any*/),
                (v30 /*: any*/),
                (v36 /*: any*/)
            ],
            "storageKey": null
        } as any)
    ], v44 = ({
        "kind": "Literal",
        "name": "refreshStream",
        "value": false
    } as any), v45 = [
        (v31 /*: any*/),
        ({
            "kind": "Variable",
            "name": "flatten",
            "variableName": "flattenReplies"
        } as any),
        (v32 /*: any*/),
        (v44 /*: any*/)
    ], v46 = ({
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v47 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v4 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v5 /*: any*/),
                    (v34 /*: any*/),
                    (v41 /*: any*/),
                    (v14 /*: any*/),
                    (v35 /*: any*/),
                    (v16 /*: any*/),
                    (v13 /*: any*/),
                    (v6 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v8 /*: any*/),
                    (v38 /*: any*/),
                    (v39 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v40 /*: any*/),
                    (v11 /*: any*/),
                    (v22 /*: any*/),
                    (v37 /*: any*/),
                    (v29 /*: any*/),
                    (v30 /*: any*/),
                    (v36 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v48 = [
        "orderBy",
        "refreshStream"
    ], v49 = ({
        "alias": null,
        "args": (v45 /*: any*/),
        "filters": (v48 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v50 = ({
        "condition": "flattenReplies",
        "kind": "Condition",
        "passingValue": false,
        "selections": (v43 /*: any*/)
    } as any), v51 = ({
        "condition": "flattenReplies",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": null,
                "args": (v45 /*: any*/),
                "concreteType": "CommentsConnection",
                "kind": "LinkedField",
                "name": "replies",
                "plural": false,
                "selections": [
                    (v47 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v5 /*: any*/),
                                    (v34 /*: any*/),
                                    (v41 /*: any*/),
                                    (v14 /*: any*/),
                                    (v35 /*: any*/),
                                    (v16 /*: any*/),
                                    (v13 /*: any*/),
                                    (v6 /*: any*/),
                                    (v17 /*: any*/),
                                    (v18 /*: any*/),
                                    (v8 /*: any*/),
                                    (v38 /*: any*/),
                                    (v39 /*: any*/),
                                    (v19 /*: any*/),
                                    (v20 /*: any*/),
                                    (v21 /*: any*/),
                                    (v40 /*: any*/),
                                    (v11 /*: any*/),
                                    (v22 /*: any*/),
                                    (v37 /*: any*/),
                                    (v29 /*: any*/),
                                    (v30 /*: any*/),
                                    (v36 /*: any*/),
                                    (v23 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            (v23 /*: any*/),
                            (v4 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v46 /*: any*/)
                ],
                "storageKey": null
            },
            (v49 /*: any*/)
        ]
    } as any), v52 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v4 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v5 /*: any*/),
                    (v34 /*: any*/),
                    (v41 /*: any*/),
                    (v14 /*: any*/),
                    (v35 /*: any*/),
                    (v16 /*: any*/),
                    (v13 /*: any*/),
                    (v6 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v8 /*: any*/),
                    (v38 /*: any*/),
                    (v39 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v40 /*: any*/),
                    (v11 /*: any*/),
                    (v22 /*: any*/),
                    (v37 /*: any*/),
                    (v29 /*: any*/),
                    (v30 /*: any*/),
                    (v36 /*: any*/),
                    (v50 /*: any*/),
                    (v51 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v53 = ({
        "alias": null,
        "args": (v33 /*: any*/),
        "filters": (v48 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v54 = [
        (v31 /*: any*/),
        (v32 /*: any*/),
        (v44 /*: any*/)
    ], v55 = ({
        "alias": null,
        "args": (v54 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v52 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v5 /*: any*/),
                            (v34 /*: any*/),
                            (v41 /*: any*/),
                            (v14 /*: any*/),
                            (v35 /*: any*/),
                            (v16 /*: any*/),
                            (v13 /*: any*/),
                            (v6 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v8 /*: any*/),
                            (v38 /*: any*/),
                            (v39 /*: any*/),
                            (v19 /*: any*/),
                            (v20 /*: any*/),
                            (v21 /*: any*/),
                            (v40 /*: any*/),
                            (v11 /*: any*/),
                            (v22 /*: any*/),
                            (v37 /*: any*/),
                            (v29 /*: any*/),
                            (v30 /*: any*/),
                            (v36 /*: any*/),
                            (v23 /*: any*/),
                            (v50 /*: any*/),
                            (v51 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v4 /*: any*/)
                ],
                "storageKey": null
            },
            (v46 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
    } as any), v56 = ({
        "alias": null,
        "args": (v54 /*: any*/),
        "filters": (v48 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v57 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v4 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v5 /*: any*/),
                    (v34 /*: any*/),
                    (v41 /*: any*/),
                    (v14 /*: any*/),
                    (v35 /*: any*/),
                    (v16 /*: any*/),
                    (v13 /*: any*/),
                    (v6 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v8 /*: any*/),
                    (v38 /*: any*/),
                    (v39 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v40 /*: any*/),
                    (v11 /*: any*/),
                    (v22 /*: any*/),
                    (v37 /*: any*/),
                    (v29 /*: any*/),
                    (v30 /*: any*/),
                    (v36 /*: any*/),
                    (v55 /*: any*/),
                    (v56 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v58 = ({
        "alias": null,
        "args": (v54 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v57 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v5 /*: any*/),
                            (v34 /*: any*/),
                            (v41 /*: any*/),
                            (v14 /*: any*/),
                            (v35 /*: any*/),
                            (v16 /*: any*/),
                            (v13 /*: any*/),
                            (v6 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v8 /*: any*/),
                            (v38 /*: any*/),
                            (v39 /*: any*/),
                            (v19 /*: any*/),
                            (v20 /*: any*/),
                            (v21 /*: any*/),
                            (v40 /*: any*/),
                            (v11 /*: any*/),
                            (v22 /*: any*/),
                            (v37 /*: any*/),
                            (v29 /*: any*/),
                            (v30 /*: any*/),
                            (v36 /*: any*/),
                            (v55 /*: any*/),
                            (v56 /*: any*/),
                            (v23 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v4 /*: any*/)
                ],
                "storageKey": null
            },
            (v46 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
    } as any), v59 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v4 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v5 /*: any*/),
                    (v34 /*: any*/),
                    (v41 /*: any*/),
                    (v14 /*: any*/),
                    (v35 /*: any*/),
                    (v16 /*: any*/),
                    (v13 /*: any*/),
                    (v6 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v8 /*: any*/),
                    (v38 /*: any*/),
                    (v39 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v40 /*: any*/),
                    (v11 /*: any*/),
                    (v22 /*: any*/),
                    (v37 /*: any*/),
                    (v29 /*: any*/),
                    (v30 /*: any*/),
                    (v36 /*: any*/),
                    (v58 /*: any*/),
                    (v56 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v60 = ({
        "alias": null,
        "args": (v54 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v59 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v5 /*: any*/),
                            (v34 /*: any*/),
                            (v41 /*: any*/),
                            (v14 /*: any*/),
                            (v35 /*: any*/),
                            (v16 /*: any*/),
                            (v13 /*: any*/),
                            (v6 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v8 /*: any*/),
                            (v38 /*: any*/),
                            (v39 /*: any*/),
                            (v19 /*: any*/),
                            (v20 /*: any*/),
                            (v21 /*: any*/),
                            (v40 /*: any*/),
                            (v11 /*: any*/),
                            (v22 /*: any*/),
                            (v37 /*: any*/),
                            (v29 /*: any*/),
                            (v30 /*: any*/),
                            (v36 /*: any*/),
                            (v58 /*: any*/),
                            (v56 /*: any*/),
                            (v23 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v4 /*: any*/)
                ],
                "storageKey": null
            },
            (v46 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
    } as any), v61 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v4 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v5 /*: any*/),
                    (v34 /*: any*/),
                    (v41 /*: any*/),
                    (v14 /*: any*/),
                    (v35 /*: any*/),
                    (v16 /*: any*/),
                    (v13 /*: any*/),
                    (v6 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v8 /*: any*/),
                    (v38 /*: any*/),
                    (v39 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v40 /*: any*/),
                    (v11 /*: any*/),
                    (v22 /*: any*/),
                    (v37 /*: any*/),
                    (v29 /*: any*/),
                    (v30 /*: any*/),
                    (v36 /*: any*/),
                    (v60 /*: any*/),
                    (v56 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v62 = ({
        "alias": null,
        "args": (v54 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v61 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v5 /*: any*/),
                            (v34 /*: any*/),
                            (v41 /*: any*/),
                            (v14 /*: any*/),
                            (v35 /*: any*/),
                            (v16 /*: any*/),
                            (v13 /*: any*/),
                            (v6 /*: any*/),
                            (v17 /*: any*/),
                            (v18 /*: any*/),
                            (v8 /*: any*/),
                            (v38 /*: any*/),
                            (v39 /*: any*/),
                            (v19 /*: any*/),
                            (v20 /*: any*/),
                            (v21 /*: any*/),
                            (v40 /*: any*/),
                            (v11 /*: any*/),
                            (v22 /*: any*/),
                            (v37 /*: any*/),
                            (v29 /*: any*/),
                            (v30 /*: any*/),
                            (v36 /*: any*/),
                            (v60 /*: any*/),
                            (v56 /*: any*/),
                            (v23 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v4 /*: any*/)
                ],
                "storageKey": null
            },
            (v46 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
    } as any), v63 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v4 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v5 /*: any*/),
                    (v34 /*: any*/),
                    (v41 /*: any*/),
                    (v14 /*: any*/),
                    (v35 /*: any*/),
                    (v16 /*: any*/),
                    (v13 /*: any*/),
                    (v6 /*: any*/),
                    (v17 /*: any*/),
                    (v18 /*: any*/),
                    (v8 /*: any*/),
                    (v38 /*: any*/),
                    (v39 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v21 /*: any*/),
                    (v40 /*: any*/),
                    (v11 /*: any*/),
                    (v22 /*: any*/),
                    (v37 /*: any*/),
                    (v29 /*: any*/),
                    (v30 /*: any*/),
                    (v36 /*: any*/),
                    (v62 /*: any*/),
                    (v56 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "CreateCommentReplyMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v3 /*: any*/),
                    "concreteType": "CreateCommentReplyPayload",
                    "kind": "LinkedField",
                    "name": "createCommentReply",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edge",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        (v6 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Story",
                                            "kind": "LinkedField",
                                            "name": "story",
                                            "plural": false,
                                            "selections": [
                                                (v7 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "parent",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/),
                                                (v8 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "args": [
                                                (v9 /*: any*/)
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "AllCommentsTabCommentContainer_comment"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v10 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Operation",
            "name": "CreateCommentReplyMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v3 /*: any*/),
                    "concreteType": "CreateCommentReplyPayload",
                    "kind": "LinkedField",
                    "name": "createCommentReply",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edge",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        (v11 /*: any*/),
                                        (v14 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "parent",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/),
                                                (v15 /*: any*/),
                                                (v8 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v16 /*: any*/),
                                        (v13 /*: any*/),
                                        (v6 /*: any*/),
                                        (v17 /*: any*/),
                                        (v18 /*: any*/),
                                        (v8 /*: any*/),
                                        (v19 /*: any*/),
                                        (v20 /*: any*/),
                                        (v21 /*: any*/),
                                        (v22 /*: any*/),
                                        (v29 /*: any*/),
                                        (v30 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Story",
                                            "kind": "LinkedField",
                                            "name": "story",
                                            "plural": false,
                                            "selections": [
                                                (v24 /*: any*/),
                                                (v5 /*: any*/),
                                                (v7 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v33 /*: any*/),
                                            "concreteType": "CommentsConnection",
                                            "kind": "LinkedField",
                                            "name": "replies",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CommentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Comment",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                (v34 /*: any*/),
                                                                (v14 /*: any*/),
                                                                (v35 /*: any*/),
                                                                (v16 /*: any*/),
                                                                (v13 /*: any*/),
                                                                (v6 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v18 /*: any*/),
                                                                (v8 /*: any*/),
                                                                (v19 /*: any*/),
                                                                (v20 /*: any*/),
                                                                (v21 /*: any*/),
                                                                (v11 /*: any*/),
                                                                (v22 /*: any*/),
                                                                (v29 /*: any*/),
                                                                (v30 /*: any*/),
                                                                (v36 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": (v33 /*: any*/),
                                                                    "concreteType": "CommentsConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "replies",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "CommentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Comment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v5 /*: any*/),
                                                                                        (v34 /*: any*/),
                                                                                        (v14 /*: any*/),
                                                                                        (v35 /*: any*/),
                                                                                        (v16 /*: any*/),
                                                                                        (v13 /*: any*/),
                                                                                        (v6 /*: any*/),
                                                                                        (v17 /*: any*/),
                                                                                        (v18 /*: any*/),
                                                                                        (v8 /*: any*/),
                                                                                        (v19 /*: any*/),
                                                                                        (v20 /*: any*/),
                                                                                        (v21 /*: any*/),
                                                                                        (v11 /*: any*/),
                                                                                        (v22 /*: any*/),
                                                                                        (v29 /*: any*/),
                                                                                        (v30 /*: any*/),
                                                                                        (v36 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": (v33 /*: any*/),
                                                                                            "concreteType": "CommentsConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "replies",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "CommentEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "Comment",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                (v5 /*: any*/),
                                                                                                                (v34 /*: any*/),
                                                                                                                (v14 /*: any*/),
                                                                                                                (v35 /*: any*/),
                                                                                                                (v16 /*: any*/),
                                                                                                                (v13 /*: any*/),
                                                                                                                (v6 /*: any*/),
                                                                                                                (v17 /*: any*/),
                                                                                                                (v18 /*: any*/),
                                                                                                                (v8 /*: any*/),
                                                                                                                (v19 /*: any*/),
                                                                                                                (v20 /*: any*/),
                                                                                                                (v21 /*: any*/),
                                                                                                                (v11 /*: any*/),
                                                                                                                (v22 /*: any*/),
                                                                                                                (v29 /*: any*/),
                                                                                                                (v30 /*: any*/),
                                                                                                                (v36 /*: any*/),
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": (v33 /*: any*/),
                                                                                                                    "concreteType": "CommentsConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "replies",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "CommentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "alias": null,
                                                                                                                                    "args": null,
                                                                                                                                    "concreteType": "Comment",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        (v5 /*: any*/),
                                                                                                                                        (v34 /*: any*/),
                                                                                                                                        (v14 /*: any*/),
                                                                                                                                        (v35 /*: any*/),
                                                                                                                                        (v16 /*: any*/),
                                                                                                                                        (v13 /*: any*/),
                                                                                                                                        (v6 /*: any*/),
                                                                                                                                        (v17 /*: any*/),
                                                                                                                                        (v18 /*: any*/),
                                                                                                                                        (v8 /*: any*/),
                                                                                                                                        (v19 /*: any*/),
                                                                                                                                        (v20 /*: any*/),
                                                                                                                                        (v21 /*: any*/),
                                                                                                                                        (v11 /*: any*/),
                                                                                                                                        (v22 /*: any*/),
                                                                                                                                        (v29 /*: any*/),
                                                                                                                                        (v30 /*: any*/),
                                                                                                                                        (v36 /*: any*/),
                                                                                                                                        {
                                                                                                                                            "alias": null,
                                                                                                                                            "args": (v33 /*: any*/),
                                                                                                                                            "concreteType": "CommentsConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "replies",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "alias": null,
                                                                                                                                                    "args": null,
                                                                                                                                                    "concreteType": "CommentEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "alias": null,
                                                                                                                                                            "args": null,
                                                                                                                                                            "concreteType": "Comment",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                (v5 /*: any*/),
                                                                                                                                                                (v34 /*: any*/),
                                                                                                                                                                (v14 /*: any*/),
                                                                                                                                                                (v35 /*: any*/),
                                                                                                                                                                (v16 /*: any*/),
                                                                                                                                                                (v13 /*: any*/),
                                                                                                                                                                (v6 /*: any*/),
                                                                                                                                                                (v17 /*: any*/),
                                                                                                                                                                (v18 /*: any*/),
                                                                                                                                                                (v8 /*: any*/),
                                                                                                                                                                (v19 /*: any*/),
                                                                                                                                                                (v20 /*: any*/),
                                                                                                                                                                (v21 /*: any*/),
                                                                                                                                                                (v11 /*: any*/),
                                                                                                                                                                (v22 /*: any*/),
                                                                                                                                                                (v29 /*: any*/),
                                                                                                                                                                (v30 /*: any*/),
                                                                                                                                                                (v36 /*: any*/),
                                                                                                                                                                {
                                                                                                                                                                    "alias": null,
                                                                                                                                                                    "args": (v33 /*: any*/),
                                                                                                                                                                    "concreteType": "CommentsConnection",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "replies",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "alias": null,
                                                                                                                                                                            "args": null,
                                                                                                                                                                            "concreteType": "CommentEdge",
                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                            "name": "edges",
                                                                                                                                                                            "plural": true,
                                                                                                                                                                            "selections": [
                                                                                                                                                                                {
                                                                                                                                                                                    "alias": null,
                                                                                                                                                                                    "args": null,
                                                                                                                                                                                    "concreteType": "Comment",
                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                    "name": "node",
                                                                                                                                                                                    "plural": false,
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        (v5 /*: any*/),
                                                                                                                                                                                        (v34 /*: any*/),
                                                                                                                                                                                        (v14 /*: any*/),
                                                                                                                                                                                        (v35 /*: any*/),
                                                                                                                                                                                        (v16 /*: any*/),
                                                                                                                                                                                        (v13 /*: any*/),
                                                                                                                                                                                        (v6 /*: any*/),
                                                                                                                                                                                        (v17 /*: any*/),
                                                                                                                                                                                        (v18 /*: any*/),
                                                                                                                                                                                        (v8 /*: any*/),
                                                                                                                                                                                        (v19 /*: any*/),
                                                                                                                                                                                        (v20 /*: any*/),
                                                                                                                                                                                        (v21 /*: any*/),
                                                                                                                                                                                        (v11 /*: any*/),
                                                                                                                                                                                        (v22 /*: any*/),
                                                                                                                                                                                        (v29 /*: any*/),
                                                                                                                                                                                        (v30 /*: any*/),
                                                                                                                                                                                        (v36 /*: any*/),
                                                                                                                                                                                        (v23 /*: any*/),
                                                                                                                                                                                        (v42 /*: any*/),
                                                                                                                                                                                        {
                                                                                                                                                                                            "condition": "flattenReplies",
                                                                                                                                                                                            "kind": "Condition",
                                                                                                                                                                                            "passingValue": false,
                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                {
                                                                                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                                                                                    "selections": (v43 /*: any*/)
                                                                                                                                                                                                }
                                                                                                                                                                                            ]
                                                                                                                                                                                        },
                                                                                                                                                                                        {
                                                                                                                                                                                            "condition": "flattenReplies",
                                                                                                                                                                                            "kind": "Condition",
                                                                                                                                                                                            "passingValue": true,
                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                {
                                                                                                                                                                                                    "alias": null,
                                                                                                                                                                                                    "args": (v45 /*: any*/),
                                                                                                                                                                                                    "concreteType": "CommentsConnection",
                                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                                    "name": "replies",
                                                                                                                                                                                                    "plural": false,
                                                                                                                                                                                                    "selections": [
                                                                                                                                                                                                        {
                                                                                                                                                                                                            "alias": null,
                                                                                                                                                                                                            "args": null,
                                                                                                                                                                                                            "concreteType": "CommentEdge",
                                                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                                                            "name": "edges",
                                                                                                                                                                                                            "plural": true,
                                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                                {
                                                                                                                                                                                                                    "alias": null,
                                                                                                                                                                                                                    "args": null,
                                                                                                                                                                                                                    "concreteType": "Comment",
                                                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                                                    "name": "node",
                                                                                                                                                                                                                    "plural": false,
                                                                                                                                                                                                                    "selections": [
                                                                                                                                                                                                                        (v5 /*: any*/),
                                                                                                                                                                                                                        (v34 /*: any*/),
                                                                                                                                                                                                                        (v14 /*: any*/),
                                                                                                                                                                                                                        (v35 /*: any*/),
                                                                                                                                                                                                                        (v16 /*: any*/),
                                                                                                                                                                                                                        (v13 /*: any*/),
                                                                                                                                                                                                                        (v6 /*: any*/),
                                                                                                                                                                                                                        (v17 /*: any*/),
                                                                                                                                                                                                                        (v18 /*: any*/),
                                                                                                                                                                                                                        (v8 /*: any*/),
                                                                                                                                                                                                                        (v19 /*: any*/),
                                                                                                                                                                                                                        (v20 /*: any*/),
                                                                                                                                                                                                                        (v21 /*: any*/),
                                                                                                                                                                                                                        (v11 /*: any*/),
                                                                                                                                                                                                                        (v22 /*: any*/),
                                                                                                                                                                                                                        (v29 /*: any*/),
                                                                                                                                                                                                                        (v30 /*: any*/),
                                                                                                                                                                                                                        (v36 /*: any*/),
                                                                                                                                                                                                                        (v23 /*: any*/),
                                                                                                                                                                                                                        (v42 /*: any*/)
                                                                                                                                                                                                                    ],
                                                                                                                                                                                                                    "storageKey": null
                                                                                                                                                                                                                },
                                                                                                                                                                                                                (v23 /*: any*/),
                                                                                                                                                                                                                (v4 /*: any*/)
                                                                                                                                                                                                            ],
                                                                                                                                                                                                            "storageKey": null
                                                                                                                                                                                                        },
                                                                                                                                                                                                        (v46 /*: any*/),
                                                                                                                                                                                                        {
                                                                                                                                                                                                            "kind": "ClientExtension",
                                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                                (v47 /*: any*/)
                                                                                                                                                                                                            ]
                                                                                                                                                                                                        }
                                                                                                                                                                                                    ],
                                                                                                                                                                                                    "storageKey": null
                                                                                                                                                                                                },
                                                                                                                                                                                                (v49 /*: any*/)
                                                                                                                                                                                            ]
                                                                                                                                                                                        }
                                                                                                                                                                                    ],
                                                                                                                                                                                    "storageKey": null
                                                                                                                                                                                },
                                                                                                                                                                                (v4 /*: any*/)
                                                                                                                                                                            ],
                                                                                                                                                                            "storageKey": null
                                                                                                                                                                        },
                                                                                                                                                                        (v46 /*: any*/),
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ClientExtension",
                                                                                                                                                                            "selections": [
                                                                                                                                                                                (v52 /*: any*/)
                                                                                                                                                                            ]
                                                                                                                                                                        }
                                                                                                                                                                    ],
                                                                                                                                                                    "storageKey": null
                                                                                                                                                                },
                                                                                                                                                                (v53 /*: any*/),
                                                                                                                                                                (v23 /*: any*/),
                                                                                                                                                                (v42 /*: any*/)
                                                                                                                                                            ],
                                                                                                                                                            "storageKey": null
                                                                                                                                                        },
                                                                                                                                                        (v4 /*: any*/)
                                                                                                                                                    ],
                                                                                                                                                    "storageKey": null
                                                                                                                                                },
                                                                                                                                                (v46 /*: any*/),
                                                                                                                                                {
                                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                                    "selections": [
                                                                                                                                                        (v57 /*: any*/)
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": null
                                                                                                                                        },
                                                                                                                                        (v53 /*: any*/),
                                                                                                                                        (v23 /*: any*/),
                                                                                                                                        (v42 /*: any*/)
                                                                                                                                    ],
                                                                                                                                    "storageKey": null
                                                                                                                                },
                                                                                                                                (v4 /*: any*/)
                                                                                                                            ],
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        (v46 /*: any*/),
                                                                                                                        {
                                                                                                                            "kind": "ClientExtension",
                                                                                                                            "selections": [
                                                                                                                                (v59 /*: any*/)
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v53 /*: any*/),
                                                                                                                (v23 /*: any*/),
                                                                                                                (v42 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v4 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v46 /*: any*/),
                                                                                                {
                                                                                                    "kind": "ClientExtension",
                                                                                                    "selections": [
                                                                                                        (v61 /*: any*/)
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v53 /*: any*/),
                                                                                        (v23 /*: any*/),
                                                                                        (v42 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v4 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v46 /*: any*/),
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                (v63 /*: any*/)
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v53 /*: any*/),
                                                                (v23 /*: any*/),
                                                                (v42 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v46 /*: any*/),
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentEdge",
                                                            "kind": "LinkedField",
                                                            "name": "viewNewEdges",
                                                            "plural": true,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Comment",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v5 /*: any*/),
                                                                        (v34 /*: any*/),
                                                                        (v41 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        (v35 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v13 /*: any*/),
                                                                        (v6 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        (v8 /*: any*/),
                                                                        (v38 /*: any*/),
                                                                        (v39 /*: any*/),
                                                                        (v19 /*: any*/),
                                                                        (v20 /*: any*/),
                                                                        (v21 /*: any*/),
                                                                        (v40 /*: any*/),
                                                                        (v11 /*: any*/),
                                                                        (v22 /*: any*/),
                                                                        (v37 /*: any*/),
                                                                        (v29 /*: any*/),
                                                                        (v30 /*: any*/),
                                                                        (v36 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": (v54 /*: any*/),
                                                                            "concreteType": "CommentsConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "replies",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v63 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "CommentEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Comment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v5 /*: any*/),
                                                                                                (v34 /*: any*/),
                                                                                                (v41 /*: any*/),
                                                                                                (v14 /*: any*/),
                                                                                                (v35 /*: any*/),
                                                                                                (v16 /*: any*/),
                                                                                                (v13 /*: any*/),
                                                                                                (v6 /*: any*/),
                                                                                                (v17 /*: any*/),
                                                                                                (v18 /*: any*/),
                                                                                                (v8 /*: any*/),
                                                                                                (v38 /*: any*/),
                                                                                                (v39 /*: any*/),
                                                                                                (v19 /*: any*/),
                                                                                                (v20 /*: any*/),
                                                                                                (v21 /*: any*/),
                                                                                                (v40 /*: any*/),
                                                                                                (v11 /*: any*/),
                                                                                                (v22 /*: any*/),
                                                                                                (v37 /*: any*/),
                                                                                                (v29 /*: any*/),
                                                                                                (v30 /*: any*/),
                                                                                                (v36 /*: any*/),
                                                                                                (v62 /*: any*/),
                                                                                                (v56 /*: any*/),
                                                                                                (v23 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v4 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v46 /*: any*/)
                                                                            ],
                                                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
                                                                        },
                                                                        (v56 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        (v53 /*: any*/),
                                        (v42 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v10 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "e034ba6ef01653c4e1747f017f6f9f37",
            "metadata": {},
            "name": "CreateCommentReplyMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '19e2e4b5d7f33fadfddd9f263ed675fb';
export default node;
